<template>
  <div class="baxia-trace-page">
    <!-- 顶部banner -->
    <img class="banner-img" src="/static/images/bx/banner.png">
    
    <!-- Trace页面内容 -->
    <div class="trace-content">
      <!-- 晶石构成明细标题 -->
      <div class="crystal-title">晶石构成明细</div>
      
      <!-- 晶石构成表格 -->
      <div v-if="crystalList && crystalList.length > 0" class="crystal-table">
        <div class="table-container">
          <!-- 表头 -->
          <div class="table-header">
            <div class="header-cell">晶石名称</div>
            <div class="header-cell">数量</div>
            <div class="header-cell">特征说明</div>
          </div>
          
          <!-- 表格内容 -->
          <div v-for="(item, index) in crystalList" :key="index" class="table-row">
            <div class="table-cell">{{ item.name }}</div>
            <div class="table-cell">{{ item.quantity }}颗</div>
            <div class="table-cell">{{ item.feature }}</div>
          </div>
        </div>
      </div>
      
      <!-- 产品说明文字 -->
      <div class="product-description">
        本产品所用晶石均为天然形成矿物晶体，经长期地质作用逐步生成。每一颗晶石在生长过程中形成独有纹理与结构。
      </div>
      
      <!-- 品质管控流程标题 -->
      <div class="process-title">天然水晶品质管控流程</div>
      
      <!-- 匠心工艺小字 -->
      <div class="craftsmanship-text">匠心工艺·溯源保障</div>
      
      <!-- 品质管控流程阶段 -->
      <div class="process-stages">
        <div class="stage">
          <img class="stage-icon" src="/static/images/bx/kuangshi.png">
          <div class="stage-text">天然原石<br>人工初筛</div>
          <div class="stage-desc">工匠经验性筛选<br>剔除瑕疵原石</div>
        </div>
        <img class="stage-arrow" src="/static/images/bx/right.png">
        <div class="stage">
          <img class="stage-icon" src="/static/images/bx/smallquery.png">
          <div class="stage-text">晶体结构<br>通透度复检</div>
          <div class="stage-desc">仪器科学检测<br>评估晶体品质</div>
        </div>
        <img class="stage-arrow" src="/static/images/bx/right.png">
        <div class="stage stage-3">
          <img class="stage-icon" src="/static/images/bx/sanyuan.png">
          <div class="stage-text">按配比<br>手工配石</div>
          <div class="stage-desc">根据设计图纸<br>手工搭配水晶</div>
        </div>
      </div>
      
      <!-- 阶段4 -->
      <div class="process-stages">
        <div class="stage">
          <img class="stage-icon" src="/static/images/bx/qrcode.png">
          <div class="stage-text">编号入库<br>溯源绑定</div>
          <div class="stage-desc">赋予唯一编号<br>建立溯源体系</div>
        </div>
        <img class="stage-arrow" src="/static/images/bx/left.png">
        <div class="stage">
          <img class="stage-icon" src="/static/images/bx/yuan.png">
          <div class="stage-text">成品结构<br>佩戴舒适度检查</div>
          <div class="stage-desc">结构稳定性测试<br>舒适度评估</div>
        </div>
      </div>
      
      <!-- 天然晶石说明文字 -->
      <div class="natural-crystal-description">
        天然晶石可能存在冰裂、棉絮、色带差异或内含物，属自然形成特征，并非人工瑕疵。
      </div>
      
      <!-- 能量信息卡片 -->
      <div v-if="processDetails" class="energy-card">
        <!-- 能量关键词 -->
        <div v-if="keywordList && keywordList.length > 0" class="energy-section">
          <div class="section-title">能量关键词</div>
          <div class="energy-keywords">
            <span v-for="(item, index) in keywordList" :key="index">
              {{ item.name }}<span v-if="index < keywordList.length - 1" class="separator">｜</span>
            </span>
          </div>
        </div>
        
        <!-- 灰色分隔线 -->
        <div v-if="keywordList && keywordList.length > 0" class="divider"></div>
        
        <!-- 能量组合逻辑 -->
        <div v-if="logicList && logicList.length > 0" class="energy-section">
          <div class="section-title">能量组合逻辑</div>
          <div class="energy-logic">
            <span v-for="(item, index) in logicList" :key="index">
              {{ item.name }}<br v-if="index < logicList.length - 1">
            </span>
          </div>
        </div>
        
        <!-- 灰色分隔线 -->
        <div v-if="logicList && logicList.length > 0"  class="divider"></div>
        
        <!-- 适合人群与使用场景 -->
        <div v-if="scenarioList && scenarioList.length > 0" class="energy-section">
          <div class="section-title">适合人群与使用场景</div>
          <div class="target-audience">
            <span v-for="(item, index) in scenarioList" :key="index">
              {{ item.name }}<br v-if="index < scenarioList.length - 1">
            </span>
          </div>
        </div>
      </div>
      
      <!-- 佩戴建议与养护卡片 -->
      <div class="energy-card">
        <!-- 佩戴建议 -->
        <div class="energy-section">
          <div class="section-title">佩戴建议</div>
          <div class="energy-logic">
            日常佩戴左右手均可，根据个人习惯选择<br>
            工作、冥想、独处时佩戴效果更佳
          </div>
        </div>
        
        <!-- 灰色分隔线 -->
        <div class="divider"></div>
        
        <!-- 净化与养护建议 -->
        <div class="energy-section">
          <div class="section-title">净化与养护建议</div>
          <div class="energy-logic">
            月光静置         ｜         白水晶共放         ｜         香薰或鼠尾草轻熏<br>
            避免长时间暴晒与接触化学制品
          </div>
        </div>
      </div>
      
      <!-- 品牌寄语与免责声明卡片 -->
      <div class="energy-card">
        <!-- 品牌寄语 -->
        <div class="energy-section">
          <div class="section-title">品牌寄语</div>
          <div class="energy-logic">
            我们相信，真正的能量来自长期佩戴中，<br>
            人与晶石之间的相互适应与共鸣。
          </div>
        </div>
        
        <!-- 灰色分隔线 -->
        <div class="divider"></div>
        
        <!-- 免责声明 -->
        <div class="energy-section">
          <div class="section-title">免责声明</div>
          <div class="energy-logic">
            本产品为天然饰品与能量文化表达，<br>
            不具备医疗或替代治疗作用。
          </div>
        </div>
      </div>
      
      <!-- 黑色背景框 -->
      <div class="black-box">
        <div class="black-left">
          <span class="black-text-item">领取积分</span>
          <span class="black-text-item">兑换赠品</span>
        </div>
        <div class="black-right">
          <span class="black-divider">|&nbsp;&nbsp;</span>
          <span class="black-clickable" @click="handleJoinClick">点击</span>
        </div>
      </div>
      
      <!-- 底部标语 -->
      <div class="bottom-slogan">
        自然晶石 · 能量与美学的平衡
      </div>
      
      <!-- 底部空白间距 -->
      <div class="bottom-spacing"></div>
      
      <!-- 向下连接箭头已移除 -->
      
      <!-- 这里将放置溯源页面的具体内容 -->
    </div>
  </div>
</template>

<style scoped>
.baxia-trace-page {
  width: 100vw;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}

.banner-img {
  width: 100vw;
  height: auto;
  margin-top: 0;
}

.trace-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 5vh;
}

.crystal-title {
  margin-top: 4vh;
  font-size: 4.5vw;
  color: black;
  text-align: center;
}

.crystal-table {
  margin-top: 3vh;
  width: 90vw;
  background-color: white;
  border-radius: 2vw;
  padding: 2vw 3vw 2vw 2vw;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.table-header {
  display: flex;
  background-color: white;
  min-width: 100%;
}

.header-cell {
  padding: 1.5vh 1.5vw 1.5vh 1.5vw;
  text-align: left;
  font-size: 3.5vw;
  font-weight: bold;
  color: black;
  white-space: nowrap;
}

.header-cell:first-child {
  flex: 0 0 40%;
  min-width: 8vw;
}

.header-cell:nth-child(2) {
  flex: 0 0 15%;
  min-width: 5vw;
  margin-left: 2vw;
}

.header-cell:last-child {
  flex: 0 0 45%;
  min-width: 10vw;
}

.table-row {
  display: flex;
  background-color: white;
  min-width: 100%;
}

.table-cell {
  padding: 0.5vh 1.5vw 0.5vh 1.5vw;
  text-align: left;
  font-size: 3.2vw;
  color: rgb(138, 137, 137);
  white-space: nowrap;
}

.table-cell:first-child {
  flex: 0 0 40%;
  min-width: 8vw;
}

.table-cell:nth-child(2) {
  flex: 0 0 15%;
  min-width: 5vw;
  margin-left: 2vw;
}

.table-cell:last-child {
  flex: 0 0 45%;
  min-width: 10vw;
}

.product-description {
  margin-top: 3vh;
  width: 80vw;
  color: rgb(138, 137, 137);
  font-size: 3.2vw;
  line-height: 1.5;
  text-align: justify;
}

.process-title {
  margin-top: 5vh;
  font-size: 4.5vw;
  color: black;
  text-align: center;
}

.craftsmanship-text {
  margin-top: 1vh;
  width: 80vw;
  color: rgb(138, 137, 137);
  font-size: 3.2vw;
  line-height: 1.5;
  text-align: center;
}

.process-stages {
  margin-top: 3vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90vw;
}

.stage {
  flex: 1;
  background-color: white;
  border-radius: 2vw;
  padding: 2vh 1vw;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stage-3 {
  position: relative;
}

.stage-3::after {
  content: '';
  position: absolute;
  bottom: -3vh;
  left: 2vw;
  width: 4vw;
  height: 4vw;
  background-image: url('/static/images/bx/tobottom.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.process-stages + .process-stages {
  margin-top: 4vh;
  width: 90vw;
  justify-content: center;
}

.process-stages + .process-stages .stage {
  flex: 0 0 calc((90vw - 7vw - 8vw) / 3);
}

.natural-crystal-description {
  margin-top: 5vh;
  width: 80vw;
  color: rgb(138, 137, 137);
  font-size: 3.2vw;
  line-height: 1.5;
  text-align: justify;
}

.energy-card {
  margin-top: 3vh;
  width: 90vw;
  background-color: white;
  border-radius: 2vw;
  padding: 5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.energy-section {
  width: 100%;
  text-align: center;
}

.section-title {
  font-size: 3.6vw;
  margin-bottom: 2vw;
  color: #333;
}

.energy-keywords {
  font-size: 3.2vw;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.separator {
  margin: 0 1.5vw;
  color: #999;
}

.energy-logic, .target-audience {
  font-size: 3.2vw;
  color: rgb(138, 137, 137);
  line-height: 2;
}

.divider {
  width: 80%;
  height: 1px;
  background-color: #ddd;
  margin: 5vw 0;
}

.stage-icon {
  width: 10vw;
  height: auto;
  margin-bottom: 1vh;
}

.stage-text {
  font-size: 3.2vw;
  color: black;
  margin-bottom: 1vh;
  line-height: 1.3;
}

.stage-desc {
  font-size: 2.8vw;
  color: rgb(138, 137, 137);
  line-height: 1.3;
}

.stage-content {
  font-size: 3.5vw;
  color: black;
}

.stage-arrow {
  width: 3.5vw;
  height: auto;
  margin: 0 2vw;
}

.bottom-slogan {
  margin-top: 5vh;
  font-size: 4.5vw;
  color: black;
  text-align: center;
}

.bottom-spacing {
  height: 2vh;
}

.black-box {
  width: 75vw;
  height: 5vh;
  background-color: black;
  border-radius: 5vw;
  margin: 4vh auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3vw;
}

.black-left {
  flex: 0.7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.black-left .black-text-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 3.5vw;
}

.black-right {
  flex: 0.3;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.black-right .black-divider {
  color: white;
  font-size: 3.5vw;
  margin: 0 0.5vw 0 0vw;
}

.black-right .black-clickable {
  color: white;
  font-size: 3.5vw;
  cursor: pointer;
}


</style>

<script>
import { getInfoByCode, getByProductId, getWechatAuth } from '../../api/api'

export default {
  name: 'BaXiaTrace',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wx1e7875f5abb1fa0a' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138823261350' : '138482046494',
      code: '',
      deptId: '',
      productId: '',
      processDetails: '',
      crystalList: [],
      keywordList: [],
      logicList: [],
      scenarioList: []
    }
  },
  methods: {
    // 方法
  },
  mounted() {
    // 从路由参数中获取c和deptId
    if (this.$route.query.c) {
      this.code = this.$route.query.c
    }
    if (this.$route.query.deptId) {
      this.deptId = this.$route.query.deptId
    }
    // 调用查询溯源接口，获取码相关信息
    this.getCodeInfo()
  },
  methods: {
    getCodeInfo() {
      getInfoByCode(this.code).then(res => {
        if (res.data && res.data.code === "200" && res.data.data) {
          if (res.data.data.productId) {
            this.productId = res.data.data.productId
            // 当productId不为空时，调用getByProductId接口
            this.getProductProcess()
          }
        }
      }).catch(err => {
        console.error('获取码相关信息失败:', err)
      })
    },
    getProductProcess() {
      getByProductId(this.productId, this.deptId).then(res => {
        if (res.data && res.data.code === 200 && res.data.data) {
          if (res.data.data.processDetails) {
            this.processDetails = res.data.data.processDetails
            try {
              const processDetailsObj = JSON.parse(this.processDetails)
              if (processDetailsObj.crystalList) {
                this.crystalList = processDetailsObj.crystalList
              }
              if (processDetailsObj.keywordList) {
                this.keywordList = processDetailsObj.keywordList
              }
              if (processDetailsObj.logicList) {
                this.logicList = processDetailsObj.logicList
              }
              if (processDetailsObj.scenarioList) {
                this.scenarioList = processDetailsObj.scenarioList
              }
            } catch (e) {
              console.error('解析processDetails失败:', e)
            }
          }
        }
      }).catch(err => {
        console.error('获取产品流程信息失败:', err)
      })
    },
    handleJoinClick() {
      const redirectUrl = window.location.origin + '/bxia/join'
      const params = new URLSearchParams()
      params.append('eno', this.eno)
      params.append('c', this.code)
      params.append('deptId', this.deptId)
      
      const fullRedirectUrl = redirectUrl + '?' + params.toString()
      
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        alert("获取微信授权失败" + err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaXia/Trace.vue